import type { Icon } from '@teachino/shared-design-system';
import type { Translation } from '@teachino/shared-i18n';

export type UpgradePageFeature = {
  icon: Icon;
  titleKey: Translation;
  descriptionKey: Translation;
};

export const UPGRADE_PAGE_FEATURES: UpgradePageFeature[] = [
  {
    icon: 'magic_wand',
    titleKey: 'upgrade.feature.ipi.title',
    descriptionKey: 'upgrade.feature.ipi.description',
  },
  {
    icon: 'file_upload',
    titleKey: 'upgrade.feature.storage.title',
    descriptionKey: 'upgrade.page.feature.storage.description',
  },
  {
    icon: 'calendar',
    titleKey: 'upgrade.usp.3',
    descriptionKey: 'upgrade.feature.personal_planning.description',
  },
  {
    icon: 'reload',
    titleKey: 'upgrade.usp.4',
    descriptionKey: 'upgrade.feature.integration.description',
  },
  {
    icon: 'share',
    titleKey: 'course_students.share_item.title',
    descriptionKey: 'upgrade.page.feature.student_share.description',
  },
  {
    icon: 'evaluate',
    titleKey: 'upgrade.feature.student_evaluation.title',
    descriptionKey: 'upgrade.feature.student_evaluation.description',
  },
  {
    icon: 'present',
    titleKey: 'upgrade.feature.presentation.title',
    descriptionKey: 'upgrade.feature.presentation.description',
  },
  {
    icon: 'file_edit',
    titleKey: 'integration.export_classregister.title',
    descriptionKey: 'upgrade.page.feature.class_register.description',
  },
];
